import KitUpdatePersTypes from 'store/actionTypes/kitUpdatePers'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  current: {},
  pagination: {}
}

const kitUpdatePers = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case KitUpdatePersTypes.GET_LIST_KIT_UPDATE_PERS_SUCCESS:
      return {
        ...state,
        list: payload?.items,
        pagination: payload?.meta
      }
    case KitUpdatePersTypes.GET_DETAIL_KIT_UPDATE_PERS_SUCCESS:
    case KitUpdatePersTypes.TRANSITION_KIT_UPDATE_PERS_SUCCESS:
      return {
        ...state,
        current: payload?.updateCampaign
      }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default kitUpdatePers
